import { render } from "./BatchReprovalConfirmationDialog.vue?vue&type=template&id=3d1c873b"
import script from "./BatchReprovalConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./BatchReprovalConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__